import x from "../common/base-feed.js";
import { logCardClick, logCardImpressions } from "../Card/index.js";
import { requestFeedRefresh } from "./request-feed-refresh.js";
export default class Feed extends x {
  constructor(r, e) {
    super(r, e);
  }
  logCardImpressions(r) {
    logCardImpressions(r, !1);
  }
  logCardClick(r) {
    logCardClick(r, !1);
  }
  sr() {
    requestFeedRefresh();
  }
  dr() {
    return !1;
  }
}
